<template>
  <div class="search">
    <el-form ref="formRef" label-width="190px">
      <el-row style="margin-bottom: 20px">
        <el-col :span="24">日期(Date)</el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="12" :xl="8">
          <el-form-item label="日期(Date)">
            <el-date-picker class="date" v-bind="dateProps" v-model="model.dateRange" :clearable="false"/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :xl="8">
          <el-form-item label="时区(UTC)">
            <el-select v-model="model.timeZone" placeholder="请选择或输入/Input or Select">
              <el-option v-for="item in timeZoneList" :key="item" :label="item" :value="item"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 20px">
        <el-col :span="24">流量范围(Traffic Range)</el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="12" :xl="8">
          <el-form-item label="媒体(Media)">
            <el-select v-model="model.mediaIds" multiple collapse-tags reserve-keyword clearable filterable placeholder="请选择或输入/Input or Select">
              <el-option v-for="item in mediaList" :key="item.id" :label="`${item.id}-${item.name}`" :value="item.id"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :xl="8">
          <el-form-item label="广告位(Ad Slot)">
            <el-select v-model="model.adzoneIds" multiple collapse-tags reserve-keyword clearable filterable placeholder="请选择或输入/Input or Select">
              <el-option v-for="item in adzoneList" :key="item.id" :label="`${item.id}-${item.name}`" :value="item.id"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :xl="8">
          <el-form-item label="操作系统(OS)">
            <el-select v-model="model.platformIds" multiple reserve-keyword clearable placeholder="请选择/Input">
              <el-option v-for="item in platformList" :key="item.id" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :xl="8">
          <el-form-item label="广告位样式(Ad Slot Type)">
            <el-select v-model="model.adResourceTypes" multiple collapse-tags reserve-keyword clearable placeholder="请选择或输入/Input or Select">
              <el-option v-for="item in adSlotTypeList" :key="item.id" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 20px;text-align: right;">
        <el-col :span="24">
          <el-button @click="resetForm">清空(Clear)</el-button>
          <el-button type="primary" @click="$emit('search')">查询(Search)</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {dateProps, getDateRange} from './schedule-date-picker-props';
import {PlatformEnum, ADSlotTypeEnum, TIMEZONE} from '@/enums/enums';
import {sspApi} from "@/api";

export default {
  props: {
    value: Object
  },
  data: function () {
    return {
      dateProps: dateProps,
      platformList: Object.values(PlatformEnum),
      adSlotTypeList: Object.values(ADSlotTypeEnum),
      timeZoneList: Object.values(TIMEZONE),
      accountList: [],
      mediaList: [],
      siteList: [],
      adzoneList: [],
      creativeTypeList:[]
    }
  },
  mounted: function () {
    sspApi.getReportConfig().then(({ adzoneList, accountList, mediaList, siteList, creativeTypeList }) => {
      this.accountList = accountList;
      this.mediaList = mediaList;
      this.siteList = siteList;
      this.adzoneList = adzoneList;
      this.creativeTypeList = creativeTypeList;
    }).catch(this.$rejectAjaxError)
  },
  computed: {
    model: function () {
      return this.value || {};
    }
  },
  methods: {
    resetForm () {
      this.$emit('input', {
        ...this.value,
        dateRange: getDateRange(),
        timeZone: TIMEZONE.UTC_8,
        mediaIds: [],
        adzoneIds: [],
        platformIds: [],
        adResourceTypes: []
      })
    }
  }
}
</script>

<style scoped>
.search {
  margin-bottom: 20px;
}

.search >>> .el-input, .search >>> .el-input__inner {
  width: 330px;
}

.search >>> .el-select .el-tag {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>